import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { GrupoUsuariosService } from 'app/main/a2w/supervisor/restricoes-permissoes/grupo-usuarios/grupo-usuarios.service';
import { combineLatest, merge, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '../sidebar/sidebar.service';
import { NavigationStateService } from './nav-state.service';

@Component({
    selector       : 'fuse-navigation',
    templateUrl    : './navigation.component.html',
    styleUrls      : ['./navigation.component.scss'],
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit
{
    @Input()
    layout = 'vertical';

    @Input()
    navigation: any[]=[];
    myForm: UntypedFormGroup;
    filteredItens: any[] = this._fuseNavigationService.getCurrentNavigation();
    aux: any[] = [];
    firstAccess: boolean = false;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private fb: UntypedFormBuilder,
        private _groupUsersService: GrupoUsuariosService,
        private _authService: AuthenticationService,
        private _navStateService: NavigationStateService,
        private _route: Router,
        private _toolbarService: ToolbarService,
        private _fuseSidebarService: FuseSidebarService,

    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

      //Configuração de badge para os itens "Gestão de Entregas" e "Funil de Vendas"
      let badgeNovoConfig: BadgeConfig = null;
      badgeNovoConfig = {
        title: 'Novo',
        bg: '#ff0000',
        fg: '#ffffff'
      }

      this._fuseNavigationService.updateNavigationItem('multiplos-funis', {
        badge: badgeNovoConfig
      });

      this._fuseNavigationService.updateNavigationItem('gestao-entregas', {
        badge: badgeNovoConfig
      });

      this.getListPermission();
      this.myForm = new UntypedFormGroup({
            campoPesquisa: new UntypedFormControl('')
          });

        // Load the navigation either from the input or from the service
      this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();
      this.navigation = this.recebeArray(this.navigation);

      this._route.events.pipe(
        takeUntil(this._unsubscribeAll),
        filter(event => event instanceof NavigationEnd)
      ).
      subscribe( async () => {
           
        const qtd: any = await this._navStateService.buscaQtdAtividade();
        let badgeConfig: any = null;
        
        if(qtd && Number(qtd.quantidadeNotificacoes) > 0) {
          badgeConfig = {
            title: qtd.quantidadeNotificacoes.toString(),
            bg: '#ff0000',
            fg: '#ffffff'
          }
        }

        this._fuseNavigationService.updateNavigationItem('todas-atividades', {
          badge: badgeConfig
        });

        this._fuseNavigationService.updateNavigationItem('agenda', {
          badge: badgeConfig
        });
        
        this.filteredItens = this._fuseNavigationService.getCurrentNavigation();
        const filtro = this.myForm.get('campoPesquisa').value.toLowerCase();
        this.filteredItens = this.filtrarItens(this.filteredItens, filtro, this.aux);
        this.filteredItens = this.recebeArray(this.filteredItens);
        this._changeDetectorRef.markForCheck();

      });

        // Subscribe to the current navigation changes
      combineLatest([this._fuseNavigationService.onNavigationChanged,
      ]).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(([navChange]) => {

                // Load the navigation
                this.navigation = this._fuseNavigationService.getCurrentNavigation();

                // Caso for o primeiro acesso do usuario, filtra para exibir apenas o grupo "Assinaturas"
                if (this._authService?.currentUserValue?.userDetails?.termoPendente) {
                  this.filteredItens =  this._fuseNavigationService.getCurrentNavigation().filter(item => item.id === 'assinaturas');
                  this.firstAccess = true;
                } else {
                  // Caso contrário, processa a navegação normalmente
                  this.filteredItens = this._fuseNavigationService.getCurrentNavigation();
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
            
        // Subscribe to navigation item
      merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
         .subscribe(() => {

             // Mark for check
             this._changeDetectorRef.markForCheck();
         });
    }

    // Função que filtra os itens do menu com base no valor de pesquisa e nas permissões do usuário
    async filtrarItensMenu() {
      const filtro = this.myForm.get('campoPesquisa').value.toLowerCase();
        
      this.filteredItens = await this.filtrarItens(this.navigation, filtro, this.aux);

      if (filtro != '') {

        setTimeout(() => {
          this._fuseNavigationService.expandirPorPesquisa = true;
          this.filteredItens.forEach((item) => {
            this._fuseNavigationService.onItemCollapsed.next(item); // dispara evento como se tivesse clicado
          });
          this._fuseNavigationService.expandirPorPesquisa = false;
        }, 0);

      } else {

        this.filteredItens = await this.filtrarItens(this.navigation, filtro, this.aux);

        //SETA UM TIMEOUT PARA ESPERAR AS ANIMAÇÕES DO MENU
        setTimeout(()=> {
          this.closeAllColapses(this.filteredItens);
          this.filteredItens = this.recebeArray(this.filteredItens);
          this._changeDetectorRef.markForCheck();
          return;
        },150);

      }
      
    }

    // Função que obtém as permissões do usuário
    async getListPermission(){
      // é uma lista de permissão de acordo com cada usuário, em seguida atribui a aux somente os valores verdadeiros, que significa que estes itens estão permitidos para determinado usuário
      if(this._authService.currentUserValue != null && this._authService.currentUserValue != undefined){
        await this._groupUsersService.listPermissions(this._authService.currentUserValue.userDetails.userGroupId).then(res => {
          this.aux = res.filter(item => (item.canRead == true && item.canWrite == true) || (item.canRead == true && item.canWrite == false));
        });
      } 
      
    }

    filtrarItens(items: any[], filtro: string, aux: any[]): any[] {
      // items.reduce, verifica se a string está no "item" 
      return items.reduce((acc, item) => {
        const includeItem = this.podeAcessarItem(item, aux) && 
                            (item.title.toLowerCase().includes(filtro) || 
                             (item.children && this.filtrarItens(item.children, filtro, aux).length > 0));
    
        if (includeItem) {
          let filteredChildren = [];
          if (item.children) {
            filteredChildren = this.filtrarItens(item.children, filtro, aux);
          }
          if (this.podeAcessarItem(item, aux)) {
            if (filteredChildren.length == 0) {
              acc.push({ ...item});
            } else {
              acc.push({ ...item, children: filteredChildren });
            }
          }
        }
        return acc;
      }, []);
    }

    // Função que verifica se o usuário tem permissão para acessar um item do menu
    podeAcessarItem(item: any, aux: any[]): boolean {
      if (item.companySystemModuleItemId) {
        return aux.some(permission => permission.companySystemModuleItemId === item.companySystemModuleItemId);
      }
      if (item.children) {
        return item.children.some(child => this.podeAcessarItem(child, aux));
      }    
      return true;
    } 

    recebeArray(navigation: any[]): any[]{
      const navZero = {...navigation[0]};
      const nav = navigation.slice(1).map(item => ({ ...item }));
      navigation = [navZero, ...nav]
      return navigation;
    }

    closeAllColapses(items: any[]): void {
      items.forEach(item => {
        if(item.type == 'collapsable') {
          item.open = false;
        }

        if(item.children) {
          this.closeAllColapses(item.children);
        }
      })
    }

}

export interface BadgeConfig {
    title?: string;
    bg: string;
    fg: string;
}


